import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
} from '@mui/material';
import { ZAvatar } from '@marageti/z4-lib';
import { TeamMember } from '@marageti/z4-sdk/lib/people';

type SelectTeamMemberDialogProps = {
  title: string,
  open: boolean,
  onClose: () => void,
  teamMembers: TeamMember[],
  onSelectTeamMember: (teamMember: TeamMember) => void,
};

const SelectTeamMemberDialog = ({
  title,
  open,
  onClose,
  teamMembers,
  onSelectTeamMember,
}: SelectTeamMemberDialogProps) => {
  const handleItemClick = (selectedTeamMember: TeamMember) => {
    onSelectTeamMember(selectedTeamMember);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle>
        {title}
      </DialogTitle>
      <DialogContent>
        <List>
          {teamMembers.map((teamMember) => (
            <ListItemButton
              disableGutters
              key={teamMember.id}
              onClick={() => handleItemClick(teamMember)}
            >
              <ListItemAvatar>
                <ZAvatar
                  size={32}
                  src={teamMember.avatar}
                  name={teamMember.fullName}
                />
              </ListItemAvatar>
              <ListItemText
                primary={teamMember.fullName}
                primaryTypographyProps={{
                  variant: 'bodyBold',
                }}
              />
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="primary"
          onClick={onClose}
          fullWidth
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SelectTeamMemberDialog;
